//Locations slider swiper
if ($('.locations__slider').length > 0) {
    const swiper = new Swiper('.locations__slider', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 34,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        // Responsive breakpoints
        breakpoints: {
            280: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            },
        },
    });
}